import axios from "axios";

export const SetLocationMy = {
  methods: {
    async SetMyLocationMethod() {
      console.log("hiiii");
      try {
        const payload = {
          considerIp: "true",
        };

        const response = await axios.post(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          payload
        );
        const { lat, lng } = response.data.location;

        let StartLocation = [
          lat,
          lng,
          await this.convertCoordinatesToAddress(lat, lng),
        ];
        let StartDate = null;
        StartDate = new Date().getTime();
        console.log("niranjan", StartDate);
        this.$store.commit("SET_COMPLETE_DATA", { StartDate, StartLocation });
      } catch (error) {
        console.log(error);
      }
    },
    async getPublicIP() {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        const ipAddress = response.data.ip;
        console.log("Public IP Address:", ipAddress);
        return ipAddress;
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    },
    convertCoordinatesToAddress(lat, lng) {
      return new Promise((resolve) => {
        const xhttp = new XMLHttpRequest();
        xhttp.open(
          "GET",
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`,
          true
        );
        xhttp.send();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            const response = JSON.parse(this.responseText);
            if (response.results && response.results[0]) {
              resolve(response.results[0].formatted_address);
            } else {
              resolve("Address not found");
            }
          }
        };
      });
    },
  },
};
